import { CAMPAIGN_LABEL_CATEGORY } from '../renderers/condition/constants';
import { ClientDataType, FieldType } from '../types';
import { useMappings } from './queries';

export const useGetFieldType = (dataType: ClientDataType) => {
  const { mappings } = useMappings({ dataType });
  return (fieldName: string): FieldType => {
    if (fieldName === CAMPAIGN_LABEL_CATEGORY.field) {
      return CAMPAIGN_LABEL_CATEGORY.fieldType;
    }
    return mappings.find(({ name }) => name === fieldName)?.fieldType ?? FieldType.UNDEFINED;
  };
};
